import { render } from "./invoiceSales.vue?vue&type=template&id=42043976&scoped=true&ts=true"
import script from "./invoiceSales.vue?vue&type=script&lang=ts"
export * from "./invoiceSales.vue?vue&type=script&lang=ts"

import "./invoiceSales.vue?vue&type=style&index=0&id=42043976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42043976"]])

export default __exports__